import { useMutation, useQueryClient } from "@tanstack/react-query";
import { partyLicensesKeys } from "Api/Queries/Licenses/usePartyLicensesQuery";
import { getPartyQueryKey } from "Api/Queries/Party/usePartyQuery";
import {
  type TransferLicenseCommandResult,
  type TransferLicenseRequest,
  postLicensesPublicIDTransfer,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Variables = {
  publicID: string;
  partyPublicID: string;
  requestPayload: TransferLicenseRequest;
};

type Props = {
  onSuccess?: (data: TransferLicenseCommandResult) => void;
  onError?: () => void;
};

export const useTransferLicenseMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      ({ publicID, requestPayload }: Variables) =>
        postLicensesPublicIDTransfer(requestPayload, publicID),
    ),

    onSuccess: (
      data: TransferLicenseCommandResult,
      { partyPublicID }: Variables,
    ) => {
      queryClient.invalidateQueries({
        queryKey: partyLicensesKeys.byPartyPublicId(partyPublicID),
      });
      queryClient.invalidateQueries({
        queryKey: getPartyQueryKey(partyPublicID),
      });
      onSuccess?.(data);
    },
    onError,
  });
};
